import React from 'react';

export class Comment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.eng,
      bubble: props.lang,
      display: "block",
      img: "comments/" + props.name
    }
  }

  componentDidMount() {
    if (!this.props.lang) {
      this.setState({
        display: "none"
      });
    }

    if (this.props.img) {
      this.setState({
        img: "covers/cover_" + this.props.img
      });
    }
  }


  ChangeLang(props) {
    if (this.state.bubble === "EN") {
      this.setState({
        text: this.props.eng,
        bubble: this.props.lang
      })
    } else if (this.props.lang) {
      this.setState({
        text: this.props.other,
        bubble: "EN"
      });
    }
  }

  render() {
    return (
      <div className="comment-wrapper">
          <div className="comment-body">
              <div className="ava-comment" style={{backgroundImage: "url('./images/"+this.state.img+".jpg')"}}></div>
              <div className="comment" onClick={this.ChangeLang.bind(this)}>
                <span className="name">{this.props.name}</span>
                <p>{this.state.text}</p>
                <div className="sven swe" style={{display: this.state.display}}>{this.state.bubble}</div>
              </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Comment.js